import React, { useState } from 'react'
import messages from './messages'
import { useIntl, FormattedMessage } from 'react-intl'
import { Modal, Button, TextArea } from '@arnsbogroup/react-voicearchive'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import useApi from 'hooks/useApi'

export default NiceModal.create(({ task, order, tasks }) => {
  const [loading, setLoading] = useState(false)
  const [note, setNote] = useState('')
  const { formatMessage } = useIntl()
  const modal = useModal()

  const [settings,,, reload] = useApi(`/notification/getNotificationSettingsForTaskId?taskId=${task ? task.uid : tasks[0].uid}`)

  const onSubmit = (event) => {
    event.preventDefault()
    setLoading(true)

    const body = new FormData()
    body.append('taskIds', task ? task.uid : tasks.map(({uid}) => uid))
    body.append('customernote', note)

    fetch(`/ordertask/setCustomerNote.json`, { method: 'POST', body })
      .then((response) => response.text())
      .then(() => {
        setLoading(false)
        modal.resolve()
        modal.remove()
      })
      .catch((error) => toastr.error(error))
  }

  return (
    <Modal
      show={modal.visible}
      onClose={() => modal.remove()}
      onOutsideClick={() => modal.remove()}
      title={formatMessage(messages.title)}
    >
      <form className="space-y-8" onSubmit={onSubmit} disabled={loading}>
        <TextArea
          label="Release note"
          placeholder="This will be included in the e-mail notification to the primary and secondary contact"
          value={note}
          onChange={(event) => setNote(event.target.value)}
        />

        <ol className="list-decimal list-inside text-sm">
          <FormattedMessage
            {...messages.sideEffects}
            values={{
              li: (chunks) => <li className="">{chunks}</li>,
            }}
          />

          { settings?.TaskBypassCustomerNotificationValue === true &&
            <li>
              <FormattedMessage {...messages.bypassWarning} />
            </li>
          }
        </ol>

        <div className="flex justify-end items-center space-x-2">
          <Button type="submit" size="sm" disabled={loading}>
            { loading ? (
              <FormattedMessage {...messages.loading} />
            ) : (
              <FormattedMessage {...messages.submit} />
            ) }
          </Button>

          <Button type="button" size="sm" onClick={() => modal.remove()} variant="outline">
            <FormattedMessage {...messages.cancel} />
          </Button>
        </div>
      </form>
    </Modal>
  )
})
